"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailStatus = void 0;
var EmailStatus;
(function (EmailStatus) {
    EmailStatus["QUEUED"] = "queued";
    EmailStatus["REQUESTED"] = "requested";
    EmailStatus["FAILED"] = "failed";
})(EmailStatus = exports.EmailStatus || (exports.EmailStatus = {}));
